import { render, staticRenderFns } from "./AdoptionReport.vue?vue&type=template&id=134e512d&"
import script from "./AdoptionReport.vue?vue&type=script&lang=js&"
export * from "./AdoptionReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports